import { cn } from "@/lib/utils";

interface WizardProgressProps {
  currentIndex: number;
  totalSteps: number;
  className?: string;
}

export function WizardProgress({
  currentIndex,
  totalSteps,
  className,
}: WizardProgressProps) {
  const progress = ((currentIndex + 1) / totalSteps) * 100;

  return (
    <div
      className={cn("fixed top-0 left-0 right-0 h-1 bg-muted z-50", className)}
    >
      <div
        className="h-full w-full bg-action-fill origin-left transition-transform duration-slow ease-out"
        style={{
          transform: `scaleX(${Math.min(1, Math.max(0, progress / 100))})`,
        }}
      />
    </div>
  );
}
